module.exports = __webpack_public_path__ + "static/media/m1.ca786eb5.png";